import React from 'react';
import { Link } from 'react-router-dom';
import { ethers } from 'ethers';
import { fmtUSDT } from '../../utils/format';

const sumBig = (...vals) => {
  let acc = ethers.BigNumber.from(0);
  for (const v of vals) {
    if (!v) continue;
    try { acc = acc.add(ethers.BigNumber.from(v)); } catch {}
  }
  return acc;
};

const PendingClaimsCard = ({ user }) => {
  const r = user?.royalties || {};
  const heldAmounts = user?.heldIncomes?.amounts || [];
  const heldTotal = sumBig(...heldAmounts);
  const royaltyTotal = sumBig(r.eliteClaimable, r.proClaimable, r.globalClaimable);

  const hasRoyalty = !royaltyTotal.isZero();
  const hasHeld = !heldTotal.isZero();

  return (
    <div className="card">
      <div className="card-title">Pending Claims</div>

      <div className="grid grid-2" style={{ marginTop: 8 }}>
        <div>
          <div className="card-sub">Royalty Pools</div>
          <div className="card-value yellow">{fmtUSDT(royaltyTotal)}</div>
          <div className="card-sub">USDT across Elite + Pro + Global</div>
        </div>
        <div>
          <div className="card-sub">Held Sponsor</div>
          <div className="card-value green">{fmtUSDT(heldTotal)}</div>
          <div className="card-sub">USDT awaiting claim</div>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 8, marginTop: 14, flexWrap: 'wrap' }}>
        <Link to="/income" className={`btn ${hasRoyalty ? 'btn-primary' : 'btn-ghost'}`}>
          {hasRoyalty ? 'Claim Royalties' : 'View Royalties'}
        </Link>
        <Link to="/income" className={`btn ${hasHeld ? 'btn-success' : 'btn-ghost'}`}>
          {hasHeld ? 'Claim Held' : 'View Held'}
        </Link>
      </div>

      <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 10 }}>
        Sponsor / Level / Booster income is paid directly to your wallet on every upgrade.
      </div>
    </div>
  );
};

export default PendingClaimsCard;
